import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { RegraFiscalSchema } from '../types/RegraFiscal';

export type ApiRegraFiscalGetParams = DefaultApiParams & {
    descricao?: string;
};

const schema = registrosSchema(RegraFiscalSchema);

function apiRegraFiscalGet({ idpk, params }: { idpk?: number; params?: ApiRegraFiscalGetParams }) {
    return fetchApi({
        endpoint: 'RegraFiscal/RegraFiscal',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_REGRA_FISCAL_GET_KEY = 'apiRegraFiscalGet';

export function apiRegraFiscalGetQueryOptions({
    idpk,
    params,
}: {
    idpk?: number;
    params?: ApiRegraFiscalGetParams;
}) {
    return queryOptions({
        queryFn: () => apiRegraFiscalGet({ idpk, params }),
        queryKey: [API_REGRA_FISCAL_GET_KEY, idpk, params],
    });
}
